import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import fgSelect from './components/UIComponents/Inputs/formGroupSelect.vue'
import fgImage from './components/UIComponents/Inputs/formGroupImageSelect.vue'
import fgTextArea from './components/UIComponents/Inputs/formGrouptextArea.vue'
import DropDown from './components/UIComponents/Dropdown.vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('fg-input', fgInput);
    Vue.component('fg-select', fgSelect);
    Vue.component('fg-image', fgImage);
    Vue.component('fg-text-area', fgTextArea);
    Vue.component('drop-down', DropDown)
  }
};

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js